import PropTypes from 'prop-types';

import classNames from 'classnames';

import styles from './styles.module.less';

const FormActionBarLayout = ({
  leftSideChildren = null,
  rightSideChildren = null,
  bottomSticky = false,
  bottomStickyOffset = 0,
}) => {
  return (
    <div
      role='toolbar'
      className={classNames(styles.formActionBar, {
        [styles.sticky]: bottomSticky,
      })}
      style={{
        '--bottomStickyOffset': bottomStickyOffset + 'px',
      }}
    >
      {leftSideChildren && <div className={styles.leftSideChildren}>{leftSideChildren}</div>}
      {rightSideChildren && <div className={styles.rightSideChildren}>{rightSideChildren}</div>}
    </div>
  );
};

FormActionBarLayout.propTypes = {
  bottomSticky: PropTypes.bool,
  bottomStickyOffset: PropTypes.number,
  leftSideChildren: PropTypes.node,
  rightSideChildren: PropTypes.node,
};

export default FormActionBarLayout;
